/**
 * vue-smb-pmg-roi
 * @version 1.0.0
 * @author Erik Ondrus <erik.ondrus@avast.com>
 * @requires accounting.min.js	(j/v2/smb/vendor/accounting.min.js)
 * @requires vue-numeric.min.js	(j/v2/smb/vendor/vue-numeric.min.js)
 */

(function() {
	'use strict';

	Vue.use(VueNumeric.default); // todo
	Vue.config.devtools = true;

	var appHook = document.getElementById('vue-pmg-roi');

	if (appHook.length === 0) {
		return false;
	}

	var app = new Vue({
		el: appHook,
		delimiters: ['{%', '%}'],

		beforeCreate: function() {
			this.PRICELIST = JSON.parse(appHook.dataset.pricelist || null);
			this.PRODUCT_KEY = appHook.dataset.pricelistProductKey;
			this.HOURS_MULTIPLIER = 1.67; // what is this value?
		},

		data: {
			numberOfEndpoints: 50,
			numberOfAdmins: 1,
			averageHourlyRate: 70,
			apps: [{
				name: 'Zoom',
				minutes: 4
			}, {
				name: 'Google Chrome',
				minutes: 3
			}, {
				name: 'Mozilla Firefox',
				minutes: 3
			}, {
				name: 'Java',
				minutes: 5
			}, {
				name: 'Adobe',
				minutes: 5
			}]
		},

		computed: {
			avgNumberOfEndpoints: function() {
				if (!this.numberOfAdmins) {
					return 0;
				}
				return this.numberOfEndpoints / this.numberOfAdmins;
			},

			totalHoursSaved: function() {
				var multiplier = this.HOURS_MULTIPLIER;
				return this.apps.reduce(function(acc, val) {
					return acc + val.minutes * multiplier;
				}, 0);
			},

			unitPrice: function() {
				return this.getUnitPrice(this.PRICELIST.products[this.PRODUCT_KEY], this.avgNumberOfEndpoints);
			},

			totalLicenceCost: function() {
				return this.numberOfEndpoints * this.unitPrice;
			},

			totalSoftCostSavings: function() {
				return this.averageHourlyRate * this.totalHoursSaved;
			},

			roi: function() {
				if (!this.averageHourlyRate) {
					return 0;
				}
				return this.totalLicenceCost / this.averageHourlyRate;
			}
		},

		methods: {

			/*
			 * @param {object} pricelistProduct - specific product in pricelist
			 * @param {number} quantity - number of selected quantity => used for indetify tier price
			 * @param {number} discount - percent discount in decimal format
			 * @returns {number} Current UnitPrice
			 */
			getUnitPrice: function(pricelistProduct, quantity, discount) {
				var key = this.getTierPriceKeyForQuantity(pricelistProduct, quantity);
				var unitPrice = pricelistProduct.prices[key];
				unitPrice -= unitPrice * (discount || 0);
				return unitPrice;
			},

			/*
			 * @param {object} pricelistProduct - specific product in pricelist
			 * @param {string} quantity - number of selected quantity  => used for indetify tier price
			 * @returns {number} Key of current price level
			 */
			getTierPriceKeyForQuantity: function(pricelistProduct, quantity) {
				quantity = quantity < 1 ? 1 : quantity; // get unit price for 0 quantity
				var rangeOfquantity = this.getReversedArrayKeys(pricelistProduct.prices); // [..., "50", "20", "5", "1"]
				return rangeOfquantity.filter(function(base) {
					return quantity >= Number(base);
				})[0]; // return first key where the quantity is higher than the base
			},

			/*
			 * @param {arr} - array to process
			 * @returns {array}
			 */
			getReversedArrayKeys: function(arr) {
				return Object.keys(arr).reverse();
			},

			/*
			 * @param {number} value - Price
			 * @returns {string} Formatted price with currency symbol
			 */
			formatPrice: function(value) {
				var pricelist = this.PRICELIST;
				var fixedPrice = this.getFixedPrice(value);
				return pricelist.priceFormat.replace('#c', pricelist.currencySymbol).replace('#p', fixedPrice);
			},

			/*
			 * @param {number} value - price to fix
			 * @returns {number} Fixed price with correct separators
			 */
			getFixedPrice: function(value) {
				var decimalSeparator = this.PRICELIST.decimalSeparator,
					precision = this.PRICELIST.precision,
					thousandSeparator = this.PRICELIST.thousandSeparator;

				var fixedPrice = parseFloat(Number(value)).toFixed(precision);
				var parts = fixedPrice.toString().split('.');
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

				return parts.join(decimalSeparator);
			},

			/*
			 * @param {string} input - Value to decode (&pound;)
			 * @returns {string} Decoded value (£)
			 */
			htmlDecode: function(input) {
				var doc = new DOMParser().parseFromString(input, 'text/html');
				return doc.documentElement.textContent;
			}
		},

		filters: {
			toFixed: function(value, precision) {
				return parseFloat(Number(value)).toFixed(precision);
			}
		}
	});
})();
